import React, { useState } from 'react';
import { Modal } from './Modal';
import { PrivacyPolicyContent, TermsOfServiceContent } from './LegalContent';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-emerald-primary py-8" data-id="element-15">
        <div className="max-w-7xl mx-auto px-6" data-id="element-16">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-17">
            {/* Copyright */}
            <p className="text-cream-primary text-sm md:text-base text-center md:text-left" data-id="element-18">
              © 2024 Máster Setter. Todos los derechos reservados.
            </p>

            {/* Legal Links */}
            <div className="flex items-center gap-6" data-id="element-19">
              <button onClick={() => setShowPrivacy(true)} className="text-gold-primary text-sm md:text-base hover:underline transition-all duration-200 hover:text-gold-light" aria-label="Ver Política de Privacidad" data-id="element-20">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-gold-primary text-sm md:text-base hover:underline transition-all duration-200 hover:text-gold-light" aria-label="Ver Términos de Servicio" data-id="element-21">
                Términos de Servicio
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-22">
        <PrivacyPolicyContent data-id="element-23" />
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos de Servicio" data-id="element-24">
        <TermsOfServiceContent data-id="element-25" />
      </Modal>
    </>;
}